import { isoDayToUtcDate, plusUtcDays } from "@/utils/dates";

import { createApiClient } from "./apiClient";

export class TeamService {
  constructor(authAPIUrl) {
    this.apiClient = createApiClient(authAPIUrl, "v1/teams");
  }

  async createTeam(name, description, members, artId, external = false) {
    const res = await this.apiClient.post("", {
      name,
      description,
      members,
      art_id: artId,
      external,
    });
    return res.id;
  }

  async deleteTeam(teamId) {
    return this.apiClient.delete(teamId);
  }

  async archiveTeam(teamId) {
    return this.apiClient.patch(`${teamId}/archive`);
  }

  async getTeams(order, external = false) {
    const teams = await this.apiClient.get("", { params: { order, external } });
    return teams.map(mapTeam);
  }

  async updateTeam(teamId, name, description, members, artId) {
    return this.apiClient.patch(teamId, { name, description, members, art_id: artId });
  }

  async updateOIDCMapping(teamId, group, role) {
    return this.apiClient.patch(`${teamId}/oidc-mapping`, { group, role });
  }

  async search(name, external) {
    const teams = await this.apiClient.get("search", { params: { name, external } });
    return teams.map(mapTeam);
  }

  async getTeamMembers(teamId) {
    return this.apiClient.get(`${teamId}/members`);
  }

  async getTeamById(teamId) {
    return mapTeam(await this.apiClient.get(teamId));
  }

  async addTeamLicense(teamId) {
    return this.apiClient.patch(`${teamId}/license`);
  }

  async removeTeamLicense(teamId) {
    return this.apiClient.delete(`${teamId}/license`);
  }
}

function mapTeam({ licenses, ...team }) {
  const expiry = licenses
    .map((license) => license.expiry)
    .toSorted()
    .at(-1);
  return {
    ...team,
    expiryDate: expiry ? plusUtcDays(isoDayToUtcDate(expiry), 1) : null,
  };
}
